
// import api from '@/helpers/api'
import axios from 'axios'


// const API_READ=`https://s3.ap-southeast-1.amazonaws.com/cdn.omnihotelier.com/assets/json/countries-2.json`


export default {
  namespaced:true,
  state: {
    status: '',
    countries:[],
  },
  mutations: {
    request(state){
        state.status = 'loading'
    },
    read(state, {countries}){
        state.countries = [... countries]
    },
    error(state){
        state.status = 'error'
    },
    success(state){
      state.status = 'success'
    },
  },
  actions: {
    read({commit,state}){
        commit('request');
        if(state.countries.length > 0 ){
            return state.countries;
        }

      return new Promise((resolve, reject) => {
        axios.get('https://s3.ap-southeast-1.amazonaws.com/cdn.omnihotelier.com/assets/json/countries-2.json', { headers: { "Authorization": '' } })
          .then((result) => {
            // console.log({result});
                commit('read',{countries:result.data})
                commit('success')
                return resolve(result.data)
            // }).catch((err) => {
            }).catch((err) => {
                commit('error')
                return reject(err)
            }).finally(() => {
            });
        })
    },
  },
  getters : {
    countries: ()=>state => state.countries,
  }
}
